import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { Input } from "@frui.ts/bootstrap";
import DatePickerBox from "controls/datePickerBox";
import LicensePlateInput from "controls/licensePlateInput";
import NumberRangeInputControl from "controls/numberRangeInput";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { translateGeneral } from "utils/localizations";
import { onNumberInputKeyPress } from "utils/numberInput";
import type PayGateToTransferRefundsViewModel from "viewModels/finance/refundApprovals/payGateToTransferRefunds/payGateToTransferRefundsViewModel";
import CountrySelect from "../../../common/countrySelect";
import FilterView from "../../../common/filter";

export interface PayGateToTransferRefundsFiltersProps {
  vm: PayGateToTransferRefundsViewModel;
}

const PayGateToTransferRefundsFilters = observer((props: PayGateToTransferRefundsFiltersProps) => {
  const { vm } = props;
  const fullTextClassNames = vm.filter.fullTextSearchEnabled ? "border-success border-2" : "";

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("licensePlate", "countryId")}</Form.Label>
          <CountrySelect
            target={vm.filter}
            property="countryId"
            allowEmpty={true}
            placeholder={translateGeneral("select")}
            vm={vm.countrySelectViewModel}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("licensePlate", "licensePlate")}</Form.Label>
          <LicensePlateInput
            target={vm.filter}
            property="licensePlate"
            placeholder={translateGeneral("search")}
            className={fullTextClassNames}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "authorizedAt")}</Form.Label>
          <DatePickerBox target={vm.filter} property="authorizedDate" placeholder={translateGeneral("search")} />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("payGateRefund", "payGatePaymentIdent")}</Form.Label>
          <Input
            target={vm.filter}
            property="payGatePaymentIdent"
            placeholder={translateGeneral("search")}
            className={fullTextClassNames}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("refundOriginalPayGatePayment", "variableSymbol")}</Form.Label>
          <Input
            target={vm.filter}
            property="variableSymbol"
            placeholder={translateGeneral("search")}
            type="number"
            onKeyDown={onNumberInputKeyPress}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "paidAmount")}</Form.Label>
          <Input target={vm.filter} property="paidAmount" step={0.01} placeholder={translateGeneral("search")} type="number" />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("refund", "officialRecordId")}</Form.Label>
          <Input
            target={vm.filter}
            property="officialRecordId"
            placeholder={translateGeneral("search")}
            className={fullTextClassNames}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "invoiceNumber")}</Form.Label>
          <Input
            target={vm.filter}
            property="invoiceNumber"
            placeholder={translateGeneral("search")}
            className={fullTextClassNames}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "arn")}</Form.Label>
          <Input target={vm.filter} property="arn" placeholder={translateGeneral("search")} className={fullTextClassNames} />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "terminalId")}</Form.Label>
          <Input
            target={vm.filter}
            property="terminalId"
            placeholder={translateGeneral("search")}
            className={fullTextClassNames}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("refund", "refundAmount")}</Form.Label>
          <NumberRangeInputControl
            target={vm.filter}
            property="refundAmount"
            placeholder={translateGeneral("search")}
            step={0.1}
            min={0}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("transferRefundPayment", "transferType")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="transferType"
            items={vm.refundTransferTypeOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("refund", "refundPaymentTemplateId")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="refundPaymentTemplateId"
            items={vm.payGateToTransferRefundPaymentTemplatesOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("refund", "approvals")}</Form.Label>
          <AdvancedSelect
            target={vm}
            property="_approvalState"
            items={vm.approvalsOptions}
            allowEmpty={true}
            placeholder={translateGeneral("select")}
          />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default PayGateToTransferRefundsFilters;
